import { FC } from 'react';
import { useAsync, useServices } from '@app/hooks';
import { LanguageCode } from '@app/types';
import { createUuid } from '@app/utilities';
import { hasVariableRules, validateInput } from '@app/utilities/functions/validations';
import { Context } from './BaseComponent';
import Textarea from './Textarea';

export type PromptTextareaProps = {
  context: Context;
  hideLabel?: boolean;
  isPropertyPanel?: boolean;
  lang: LanguageCode;
  readOnly?: boolean;
  valKey?: string;
  value: Record<LanguageCode, string>;
};

export const PromptTextarea: FC<PromptTextareaProps> = ({
  context,
  hideLabel = false,
  isPropertyPanel = false,
  lang: languageCode,
  readOnly = false,
  valKey,
  value: languageValues
}) => {
  const { workflowService } = useServices();
  const [languageOptions] = useAsync(() => workflowService.getLanguages(), []);
  const value = languageValues[languageCode];
  const languageLabel = languageOptions?.find(({ value }) => value === languageCode)?.label;

  return (
    <Textarea
      key={createUuid()}
      context={context}
      valKey={valKey ?? languageCode}
      label={(hideLabel) ? undefined : languageLabel}
      lang={languageCode}
      value={value}
      highlight={true}
      hint={window.l.form.prompt_text_here}
      readOnly={readOnly}
      isPropertyPanel={isPropertyPanel}
      valRules={{ _: (value: string) => validateInput(value, [hasVariableRules]) }}
    />
  );
};
